import Vue from "vue";

const getters = {
    listOfTemplates: (state) => state.listTemplates,
    paginationTemplates: (state) => state.templatesPagination,
    getTemplateById: (state) => (id) => state.listTemplates[id],
};

const mutations = {
    ADD_TEMPLATES_TO_LIST(state, { data, pagination }) {
        data.forEach((template) => {
            Vue.set(state.listTemplates, template.id, template);
        });
        Vue.set(state, "templatesPagination", pagination);
    },

    UPDATE_TEMPLATE(state, template) {
        Vue.set(state.listTemplates, template.id, {
            ...(state.listTemplates[template.id] || {}),
            ...template,
        });
    },

    DELETE_TEMPLATE(state, id) {
        Vue.delete(state.listTemplates, id);
    },
};

const templates = {
    namespaced: true,
    state: {
        listTemplates: {},
        templatesPagination: {},
    },
    getters,
    mutations,
    actions: {
        searchTemplatesList(
            { commit },
            { page = 1, per_page = 10, query = "", sort = null, filter = [] }
        ) {
            return new Promise((resolve, reject) => {
                const payload = {
                    search: query || "",
                    sort: sort || [{ created_at: "desc" }],
                    filter: filter, // массив фильтров
                    page: page,
                    count: per_page,
                };

                this.$app.$api.templates
                    .getList(payload)
                    .then((response) => {
                        const pagination = {};
                        if (response?.data?.meta) {
                            ["current_page", "per_page", "total"].forEach((key) => {
                                if (response.data.meta[key] !== undefined)
                                    pagination[key] = response.data.meta[key];
                            });
                        }

                        if (response?.data?.data) {
                            commit("ADD_TEMPLATES_TO_LIST", {
                                data: response.data.data,
                                pagination,
                            });
                        }

                        resolve(response);
                    })
                    .catch((error) => {
                        // eslint-disable-next-line no-console
                        console.error("Ошибка при загрузке шаблонов:", error);
                        reject(error);
                    });
            });
        },
        publishTemplate({ commit }, template) {
            return this.$app.$api.templates
                .publish(template.data)
                .then((response) => {
                    // Сервер не возвращает объект, обновляем локально
                    commit("UPDATE_TEMPLATE", template);
                    return response;
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.error("Ошибка публикации шаблона:", error);
                    throw error;
                });
        },

        updateTemplate({ commit }, template) {
            return this.$app.$api.templates
                .update(template.id, template)
                .then((response) => {
                    // Сервер не возвращает объект, обновляем локально
                    commit("UPDATE_TEMPLATE", template);
                    return response;
                })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.error("Ошибка обновления шаблона:", error);
                    throw error;
                });
        },

        deleteTemplate({ commit }, template) {
            return new Promise((resolve, reject) => {
                const id = template.id;
                this.$app.$api.templates
                    .delete(id)
                    .then(() => {
                        commit("DELETE_TEMPLATE", id);
                        resolve();
                    })
                    .catch(reject);
            });
        },
        async fetchTemplateById({ state, commit }, id) {
            // Сначала проверяем в сторе
            if (state.listTemplates[id]) {
                return state.listTemplates[id];
            }

            try {
                const response = await this.$app.$api.templates.GetById(id);
                const template = response?.data?.data || response?.data;

                if (template) {
                    commit("UPDATE_TEMPLATE", template);
                    return template;
                } else {
                    throw new Error("Шаблон не найден на сервере");
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Ошибка при получении шаблона по ID:", error);
                throw error;
            }
        },
    },
};

export default templates;
